import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import React, { useEffect, useRef, useState } from "react";
import { BillableService } from "../../../services/billable-servise";
import './billable.css'
import { Toast } from 'primereact/toast';

import { Api } from "../../../services/api";
import { IoArrowBackSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Billable = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [billableList, setBillableList] = useState([]);

    const [billableColumnList, setBillableColumnList] = useState([]);


    const toast = useRef(null);
    useEffect(() => {
        // getBiliableData();
        getBiliableArchiveDataByYear();

    }, []);

    const getBiliableArchiveDataByYear = () => {
        console.log('getBiliableArchiveDataByYear')
        setIsLoading(true);
        // var _body = {
        //    year:2024


        // }

        var _body = {
            "startDate": localStorage.getItem('payPeriodStartDate'),
            "endDate": localStorage.getItem('payPeriodEndDate')

        }
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        // fetch(Api.API_BASE_URL + 'billable-pay-periods-by-year', {
        fetch(Api.API_BASE_URL + 'billable-pay-periods', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {

                if (response.error !== '') {
                } else {

                    var data = response.result;
                    var x = BillableService.getDataBilible(data);
                    setBillableList(x);

                }

                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });
        var t = BillableService.getBillableColumnData();
        setBillableColumnList(t);

    }


    const rowClass = (data) => {
        return {
            'bg-yellow-200': data.division === 'Total Field Operations' || data.division === 'Total Pre Con Estimating' || data.division === 'Total Interior Design' || data.division === 'Total Project Management' || data.division === 'Gross Pofit/Loss' || data.division === 'Total Property Management' || data.division === 'Total Sales & Marketing' || data.division === 'Total Administration' || data.division === 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' || data.division === 'Gross Pofit/Loss Administration',
            'bg-yellow-300': data.division === 'Total Field ops/ID/PM/Pre Con' || data.division === '' || data.division === 'Gross Profit/Loss' || data.division === 'Total labour burden billable vs unbillalbe Gross Profit or Loss'
        };
    };


    const headerTemplate = (data) => {
        var newStr = data.billableType;
        newStr = newStr.substring(1);
        return (

            <React.Fragment>
                <th colSpan="1" className="no-horizontal-scroll p-frozen-column myheader" style={{ border: 'none' }}>
                    <span className="flex m-3"

                        style={{ overflowX: "hidden", whiteSpace: "nowrap" }}>
                        {newStr}
                    </span>
                </th>
            </React.Fragment>
        );
    };

    const renderBodyTemplate = (col, value) => {
        if (col === 'mark_up_per' || col === 'unBillableTimePer') {
            return <span>{value.toFixed(1)}%</span>;
        }
        if (col === 'division' || col === 'name') {
            return <span>{value}</span>;
        }
        if (col === 'billableTime' || col === 'unBillableTime' || col === 'vacatiomStatTime' || col === 'eosTime' || col === 'salesTime' || col === 'sickTime' || col === 'totalHours') {
            if (value <= 0) {
                return <div >{value.toFixed(2)}</div>;

            } else {
                return <div>{value.toFixed(2)}</div>;
                // return <div className="bg-pink-100">{value.toFixed(2)}</div>;
            }
        }
        return <span>{priceBodyTemplatee(value)}</span>;
    };

    const priceBodyTemplatee = (rowData) => {
        if (rowData === '') {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {
            return '';
        }
        const isNegative = rowData < 0; // Check if the value is negative
        return <span style={{ color: isNegative ? "red" : "black" }}>
            {formatCurrency(rowData)}
        </span>
    };

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };



    return (
        <>
            <Toast ref={toast} />
            {/* Data Table  */}
            {isLoading ? (
                <div className="loading-spinner">
                    Loading...
                    <div className="spinner"></div>
                </div>
            ) : (
                <div className="card" >
                    <div className="row p-2">
                        <button type='button' onClick={() => { navigate(-1); window.close(); }} className='customSave-button m-2 flex'>
                            <IoArrowBackSharp className='text-sm' />
                            <span>Back</span>
                        </button>
                        <div className="col-3">
                            <h4 className="text-center">Pay Period Date</h4>
                        </div>
                        <div className="col-2">
                            <h4 className="text-center" style={{ color: "grey", fontWeight: 'normal' }}>{localStorage.getItem('payPeriodStartDate')} : {localStorage.getItem('payPeriodEndDate')}</h4>
                        </div>
                    </div>

                    <div className="fd" >
                        <div className=''>
                            <DataTable value={billableList} rowClassName={rowClass} stripedRows showGridlines size="large" rowGroupMode="subheader" groupRowsBy="billableType" rowGroupHeaderTemplate={headerTemplate}
                                sortMode="single" tableStyle={{ minWidth: '50rem', width: 'auto', borderCollapse: 'separate', borderSpacing: '0' }} sortField="billableType" sortOrder={1} scrollable scrollHeight="76vh" selectionMode="single"
                            >
                                {billableColumnList.map((col, i) => (
                                    <Column
                                        field={col.value}
                                        frozen={i === 0 || i === 1}
                                        key={col.value}
                                        body={(e) => renderBodyTemplate(col.value, e[col.value])}
                                        bodyClassName={(rowData) => col.value == 'billableTime' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != '' || col.value == 'unBillableTime' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'LIDA Construction Gross Pofit/Loss' || col.value == 'vacatiomStatTime' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'LIDA Construction Gross Pofit/Loss' || col.value == 'eosTime' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'LIDA Construction Gross Pofit/Loss' || col.value == 'salesTime' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'LIDA Construction Gross Pofit/Loss' || col.value == 'sickTime' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'LIDA Construction Gross Pofit/Loss' || col.value == 'totalHours' && rowData.division != 'Gross Pofit/Loss' && rowData.division != 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' && rowData.division != 'Gross Pofit/Loss Administration' && rowData.division != 'LIDA Construction Gross Pofit/Loss' ? 'archive-text' : ''}
                                        header={col.name}
                                        style={i === 1 ? { borderRight: '2px solid black', textAlign: 'left', minWidth: '200px', padding: "7px" } : i === 0 ? { minWidth: '300px', textAlign: 'left', padding: "7px" } : { minWidth: '150px', textAlign: 'center' }}
                                    >
                                    </Column>
                                ))}
                            </DataTable>
                        </div>
                    </div>
                </div>
            )}

        </>
    )

}
export default Billable